import { render, staticRenderFns } from "./InventoryItemTable.vue?vue&type=template&id=b0a472f0&scoped=true"
import script from "./InventoryItemTable.vue?vue&type=script&lang=ts"
export * from "./InventoryItemTable.vue?vue&type=script&lang=ts"
import style0 from "./InventoryItemTable.vue?vue&type=style&index=0&id=b0a472f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a472f0",
  null
  
)

export default component.exports